export default "__VITE_ASSET__6fd377c1__"